import { Tooltip } from 'antd';
import React from 'react';
import { constants } from "../constant/constants";
import { useNavigate } from "react-router-dom";

function GroupItemComponent({record, callback}) {
    const navigate = useNavigate();
    const viewGroup = () => {
        callback(record, constants.GROUP.VIEW)
    }
    const generateQr = () => {
        const qrData = {
            id: record?.groupId,
            name: record?.groupName,
            slug: record?.groupSlug,
            isRestaurant: false,
        };
        // callback(qrData, constants.GROUP.QR)
        navigate("/restaurant-qr", { state: { qrData } });
        // window.location.reload();
    }
    const deleteGroup = () => {
        callback(record, constants.STAFF.DELETE)
    }

    return (
      <div
        key={`category${record.order_id}`}
        className="flex flex-row mb-[16px]
                        font-uregular py-[16px] px-[24px]
                        rounded bg-white items-center"
      >
        <div className="flex flex-col items-start flex-grow justify-center mx-[48px]">
          <div className="text-base text-preblack font-ubold">
            {record.groupName}
          </div>
        </div>
        <div className="flex flex-col items-start justify-center mx-[48px]">
          <div className="flex flex-row text-sm text-preblack font-ubold">
            <div className="w-[90px]">Restaurants:</div>
            <div>{record.totalRestaurants}</div>
          </div>
        </div>
        <div className="flex flex-row items-center px-[8px] w-[120px]">
          <Tooltip placement="bottom" title="View Group">
            <img
              onClick={viewGroup}
              alt="View Group"
              className="w-[36px] h-[36px]"
              src={"/images/viewicon.svg"}
            />
          </Tooltip>
          <Tooltip placement="bottom" title="Generate QR">
            <img
              onClick={generateQr}
              alt="Generate QR"
              className="w-[30px] h-[30px] ml-[3px] mr-[3px]"
              src={"https://tabletap-cdn.s3.ap-south-1.amazonaws.com/tabletap-prod/static-assets/qr-logo.svg"}
            />
          </Tooltip>
          <Tooltip placement="bottom" title="Cancel Group">
            <img
              onClick={deleteGroup}
              alt=""
              className="w-[36px] h-[36px]"
              src={"/images/closeicon.svg"}
            />
          </Tooltip>
        </div>
      </div>
    );
}

export default GroupItemComponent;
